export default __webpack_public_path__ + "dafeae78aca17259b829bb3c633dc3bf.svg";